/**
 * Centralized breakpoints for JavaScript
 * Values must match SCSS variables in assets/scss/utils/_vars.scss
 */

export const BREAKPOINTS = {
  xs: 600,
  sm: 900,
  md: 1200,
  lg: 1440,
};

/**
 * Check if current viewport is extra small (mobile)
 * @returns {boolean}
 */
export const isXs = () => window.innerWidth <= BREAKPOINTS.xs;

/**
 * Check if current viewport is small (tablet portrait)
 * @returns {boolean}
 */
export const isSm = () => window.innerWidth > BREAKPOINTS.xs && window.innerWidth <= BREAKPOINTS.sm;

/**
 * Check if current viewport is medium (tablet landscape)
 * @returns {boolean}
 */
export const isMd = () => window.innerWidth > BREAKPOINTS.sm && window.innerWidth <= BREAKPOINTS.md;

/**
 * Check if current viewport is large (desktop)
 * @returns {boolean}
 */
export const isLg = () => window.innerWidth > BREAKPOINTS.md && window.innerWidth <= BREAKPOINTS.lg;

/**
 * Check if current viewport is extra large (large desktop)
 * @returns {boolean}
 */
export const isXl = () => window.innerWidth > BREAKPOINTS.lg;

/**
 * Get current breakpoint name
 * @returns {'xs'|'sm'|'md'|'lg'|'xl'}
 */
export const getCurrentBreakpoint = () => {
  const width = window.innerWidth;

  if (width <= BREAKPOINTS.xs) {
    return 'xs';
  }

  if (width <= BREAKPOINTS.sm) {
    return 'sm';
  }

  if (width <= BREAKPOINTS.md) {
    return 'md';
  }

  if (width <= BREAKPOINTS.lg) {
    return 'lg';
  }

  return 'xl';
};
